/* ============================================================
   BEAST INSIDE — site interactions (vanilla JS)
   Provides: reveal-on-scroll.

   The header, mobile menu and cart are Horizon's own Liquid sections. Until
   16 Oct 2026 this file injected its own versions of all three, on top of a
   12-product demo catalogue that never existed in Shopify. That cart lived in
   localStorage: it never saw the real Shopify cart, its count never moved, and
   its CHECKOUT button did nothing. Search and Account were dead buttons.
   The original is kept in the DK Media repo as site.original.js.
   ============================================================ */
(function(){
  "use strict";

  // The announcement bar used to be built here too. It is now the Marquee Ticker
  // section in the Header group (Size: Small), so it sits correctly with Horizon's
  // sticky header and its lines are edited in the theme editor. Rule that still
  // applies to those lines: every one must be true on the day it is live — no drop
  // named before the product exists, no discount promised before it is delivered.

  /* ---------------- Reveal on scroll ---------------- */
  function initReveals(){
    const els=document.querySelectorAll("[data-reveal]");
    if(!els.length) return;
    const reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if(reduced || !("IntersectionObserver" in window)){ return; } // leave content visible

    let armed=false, io=null;
    function arm(){
      if(armed) return; armed=true;
      document.body.classList.add("reveal-armed");
      io=new IntersectionObserver((ents)=>{
        ents.forEach(en=>{ if(en.isIntersecting){ const d=en.target.getAttribute("data-delay"); if(d) en.target.style.transitionDelay=d+"ms"; en.target.classList.add("in"); io.unobserve(en.target); } });
      },{threshold:0.12, rootMargin:"0px 0px -8% 0px"});
      els.forEach(e=>io.observe(e));
    }
    // Only arm the hidden start-state when the document is actually visible (painting),
    // so a background/non-painting load never gets stuck behind a frozen transition.
    if(document.visibilityState==="visible"){ arm(); }
    else { document.addEventListener("visibilitychange", function onVis(){ if(document.visibilityState==="visible"){ document.removeEventListener("visibilitychange",onVis); arm(); } }); }
  }

  /* ---------------- Public API ---------------- */
  // initReveals and money are real. Everything else is a stub for the removed demo
  // catalogue and cart, so any section still calling it logs a warning instead of
  // throwing and taking the rest of the page's scripts down with it. If the console
  // never shows one of these warnings, the stubs can go.
  const money = n => "£"+(Math.round(n*100)/100).toFixed(2).replace(/\.00$/,"");
  const gone = (name, value) => function(){
    if(window.console) console.warn("BI."+name+" was part of the removed demo catalogue/cart — remove whatever calls it.");
    return value;
  };
  window.BI = {
    initReveals, money, FREE_SHIP:75,
    catalog:[],
    byId:gone("byId", undefined),
    cardHTML:gone("cardHTML", ""),
    ph:gone("ph", ""),
    colorName:gone("colorName", ""),
    add:gone("add"), qty:gone("qty"), remove:gone("remove"),
    openCart:gone("openCart"), closeCart:gone("closeCart")
  };

  /* ---------------- Boot ---------------- */
  function boot(){ initReveals(); document.dispatchEvent(new Event("bi:ready")); }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",boot); else boot();
})();
